<template>
    <loading v-model:active="isLoding">        
        <div class="theme-loader">
            <div class="ball-scale">
                <div class="contain">
                    <div class="ring">
                        <div class="frame"></div>
                    </div>
                    <div class="ring">
                        <div class="frame"></div>
                    </div>
                    <div class="ring">
                        <div class="frame"></div>
                    </div>
                    <div class="ring">
                        <div class="frame"></div>
                    </div>
                    <div class="ring">
                        <div class="frame"></div>
                    </div>
                    <div class="ring">
                        <div class="frame"></div>
                    </div>
                    <div class="ring">
                        <div class="frame"></div>
                    </div>
                    <div class="ring">
                        <div class="frame"></div>
                    </div>
                    <div class="ring">
                        <div class="frame"></div>
                    </div>
                    <div class="ring">
                        <div class="frame"></div>
                    </div>
                </div>
            </div>
        </div>
    </loading>    
</template>

    <script>
        import Loading from 'vue-loading-overlay';
        import 'vue-loading-overlay/dist/css/index.css';

        export default {
            data() {
            return {
            isLoading: false,
        fullPage: true
            }
        },
        components: {
            Loading
        },
        methods: {
            doAjax() {
            this.isLoading = true;
                // simulate AJAX
                setTimeout(() => {
            this.isLoading = false
        }, 5000)
            },
        onCancel() {
            console.log('User cancelled the loader.')
        }
        }
    }
    </script>
